import { useState, useCallback } from 'react';
import { isApiError } from '@aiptyg/types';
import * as teamService from '../services/team.service';
import type { TeamDetailResponseDTO } from '../types/team.types';

const ERROR_MAP: Record<string, string> = {
  admin_role_required: '无管理员权限',
  network_error: '网络连接失败，请检查网络',
  'invalid user id': '无效的用户 ID',
  'user not found': '用户不存在',
};

function resolveError(e: unknown): string {
  if (isApiError(e)) {
    return ERROR_MAP[e.message] ?? `请求失败 (${e.message})`;
  }
  return '未知错误';
}

export function useTeamDetail() {
  const [data, setData] = useState<TeamDetailResponseDTO | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [queriedUserId, setQueriedUserId] = useState<number | null>(null);

  const query = useCallback(async (userId: number) => {
    setLoading(true);
    setError(null);
    setData(null);
    setQueriedUserId(userId);
    try {
      const result = await teamService.getTeamDetail(userId);
      setData(result);
    } catch (e) {
      setError(resolveError(e));
    } finally {
      setLoading(false);
    }
  }, []);

  const retry = useCallback(() => {
    if (queriedUserId !== null) {
      query(queriedUserId);
    }
  }, [query, queriedUserId]);

  return {
    data, loading, error, queriedUserId,
    query, retry,
  };
}
